<template>
  <div>
    <slot />
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CardContent",
  props: ["title", "color"],
  data() {
    return {};
  },
});
</script>
